import { Link } from "react-router-dom";
import LegalLayout from "./LegalLayout";

const CONTACT_EMAIL = "privacy@joint.photos";

export default function DataDeletionPage() {
  return (
    <LegalLayout title="User Data Deletion" updatedAt="2026-02-03">
      <p>
        You can request deletion of your joint.photos account and associated data at any time. We do not require you to
        sign in to make a deletion request.
      </p>

      <section>
        <h2 className="text-lg font-semibold">How to request deletion</h2>
        <ol className="mt-3 list-decimal pl-6 space-y-2">
          <li>
            Email{" "}
            <a className="underline hover:text-white" href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>{" "}
            with the subject line: <span className="font-medium">“Data deletion request”</span>.
          </li>
          <li>
            Include the email address you used with joint.photos. If you signed in with Facebook, you may also include
            your Facebook user ID if you have it (optional).
          </li>
          <li>
            We will verify the request as needed and delete your account data. Typical completion time is within{" "}
            <span className="font-medium">30 days</span>.
          </li>
        </ol>
      </section>

      <section>
        <h2 className="text-lg font-semibold">If you used Facebook Login</h2>
        <p className="mt-3">
          You can also remove joint.photos from your Facebook settings (Facebook → Settings &amp; privacy → Settings →
          Apps and websites). Removing the app from Facebook prevents future Facebook-based sign-ins, but it does not
          automatically delete data stored in joint.photos—please use the request process above if you want us to delete
          your joint.photos data.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Back</h2>
        <p className="mt-3">
          Return to the <Link className="underline hover:text-white" to="/privacy">Privacy Policy</Link> or{" "}
          <Link className="underline hover:text-white" to="/">the app</Link>.
        </p>
      </section>
    </LegalLayout>
  );
}

